EmailFormTextInputView = require "../../common/views/text_input_view"

class EmailFormUserNameInputView extends EmailFormTextInputView
  tagName: 'li'

  events:
    'keyup .user_name_input': 'validateUserName'

  initialize: ->
    EmailFormTextInputView::initialize.apply(this, arguments)
    @elementID = ".user_name_input"
    @template = {user_name_input_template: true}

  isInputValid: ()->
    return true unless @isInputElementPresent()
    @getInputHtmlElement()?.val()?.trim()?.length > 0

  isInputElementPresent: ->
    @getInputHtmlElement()?.length > 0

  validateUserName: ->
    @isInputValid()
    @validateEmailForm()

  populateInput: (data)->
    if @isInputGiven()
      data.user_name = @readInput()
      EmailFormTextInputView::populateInput.call(this, data)

module.exports = EmailFormUserNameInputView
